
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { COUNTRIES, MODAL_NAMES } from '@config/constants'
import { ROUTES } from '@router'

import translations from './ProductBanner.translations'
import TradeInModal from './components/TradeInModal'

export default {
  components: {
    SkinnyBanner: () => import('@core/components/SkinnyBanner'),
    TradeInModal,
    RevLink,
  },

  props: {
    activeGrade: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      isSkinnyBannerAvailable: 'countryConfig/isSkinnyBannerAvailable',
      country: 'config/country',
    }),

    skinnyBannerId() {
      return this.activeGrade.skinnyBannerId
    },

    hasSellerBanner() {
      return (
        this.skinnyBannerId !== null &&
        this.isSkinnyBannerAvailable('product-merchant', this.skinnyBannerId)
      )
    },

    hasProductBanner() {
      return this.isSkinnyBannerAvailable(ROUTES.PRODUCT.HOME)
    },

    skinnyBanner() {
      if (this.hasSellerBanner) {
        return {
          page: 'product-merchant',
          id: this.skinnyBannerId,
        }
      }

      if (this.hasProductBanner) {
        return {
          page: ROUTES.PRODUCT.HOME,
        }
      }

      return {}
    },

    hasSkinnyBanner() {
      return !isEmpty(this.skinnyBanner)
    },

    showSkinnyBanner() {
      return !this.showTradeInBanner && this.hasSkinnyBanner
    },

    showTradeInBanner() {
      return this.country === COUNTRIES.US
    },
  },

  methods: {
    openTradeInModal() {
      openModal(MODAL_NAMES.PRODUCT.TRADE_IN)
    },
  },
}
